/**
 * PDF.js 5 calls URL.parse(), which is unavailable in older school-managed
 * browsers even though they support the URL constructor.
 *
 * Spec: https://developer.mozilla.org/en-US/docs/Web/API/URL/parse_static
 */
export function installUrlParsePolyfill(urlCtor = globalThis.URL) {
  if (typeof urlCtor?.parse === "function") {
    return false;
  }
  if (typeof urlCtor !== "function") {
    return false;
  }

  urlCtor.parse = function parse(url, base) {
    try {
      return new urlCtor(url, base);
    } catch {
      return null;
    }
  };
  return true;
}
